import { Row } from "antd";
import styled from "styled-components";

export const ContentSection = styled.section<{ background?: string }>`
  position: relative;
  padding: 15rem 0 11rem;
  background: ${({ background }) =>
        background ? `url(${background}) no-repeat center center / cover` : "none"};
  width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 8rem 1.5rem 6rem;
    background-size: contain;
  }

  @media (min-width: 769px) and (max-width: 834px) {
    padding: 10rem 2rem 7rem;
    background-size: cover;
    background-position: center 40%;
  }

  @media (min-width: 835px) and (max-width: 1024px) {
    padding: 11rem 3rem 8rem;
    background-size: cover;
    background-position: center 45%;
  }

  @media (max-width: 575px) {
    padding: 1rem 1rem 3rem;
    background-size: contain;
    background-position: center;
  }

  @media (max-width: 375px) {
    padding: 2rem;
    background-size: contain;
    background-position: center;
  }
`;

export const ContentTitle = styled.h6`
  font-family: "Sedan SC Light", sans-serif;
  font-size: 48px;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    font-size: 42px;
    max-width: 500px;
  }

  @media (max-width: 820px) {
    font-size: 38px;
    max-width: 400px;
  }

  @media (max-width: 575px) {
    font-size: 26px;
    max-width: 280px;
  }

  @media (max-width: 375px) {
    font-size: 26px;
    max-width: 240px;
  }
`;


export const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding: 0 2rem;

  @media (max-width: 1024px) {
    padding: 0 1.5rem;
  }

  @media (max-width: 575px) {
    padding: 3rem 1rem 0;
  }
`;

export const ServiceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  padding: 0 2rem;

  @media (max-width: 1024px) {
    padding: 0 1.5rem;
  }

  @media (max-width: 575px) {
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    padding: 0 1rem;
  }
`;

export const MinTitle = styled.h6`
  font-size: 18px;
  line-height: 1.2rem;
  padding: 0.5rem 0;
  text-transform: uppercase;
  color: #000;
  font-family: "Motiva Sans Light", sans-serif;

  @media (max-width: 1024px) {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 22px;
    max-width: 220px;
    margin: 0 auto;
  }

  @media (max-width: 480px) {
    font-size: 24px;
    max-width: 180px;
  }
`;

export const MinPara = styled.p`
  font-size: 15px;
  max-width: 280px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    font-size: 16px;
    max-width: 260px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    max-width: 220px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
    max-width: 180px;
  }
`;


export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin: 0 auto;
  width: 100%;
  padding: 0 2rem;

  @media (max-width: 1024px) {
    max-width: 90%;
    padding: 0 1.5rem;
  }

  @media (max-width: 450px) {
    flex-direction: column;
    gap: 15px;
    max-width: 60%;
    padding: 0 1rem;
  }
   
  @media (max-width: 375px) {
    flex-direction: column;
    gap: 15px;
    max-width: 70%;
    padding: 0 1rem;
  }
`;


export const StyledRow = styled(Row) <{ direction: string }>`
  flex-direction: ${({ direction }) =>
        direction === "left" ? "row" : "row-reverse"};

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: center;
    text-align: center;
  }
`;
